import {Configuration} from 'configuration';
import type {HttpArgs} from './httpMethod';
import { httpMethod} from './httpMethod';
import {httpMock} from './mock';

/**
 * @private
 */
export const httpWithMock = <TResponse, TBody>({
  mock,
  ...args
}: HttpArgs<TBody> & {mock?: boolean}): Promise<TResponse> => {
  const useMock =
    (Configuration.env === 'local' || Configuration.env === 'dev') &&
    (mock || (mock === undefined && Configuration.api.mock.enabled));
  return useMock
    ? httpMock<TResponse, TBody>(args)
    : httpMethod<TResponse, TBody>(args);
};
